/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use strict";Object.defineProperty(exports,Symbol.toStringTag,{value:"Module"});const l=require("@progress/kendo-intl"),e={},n=(...t)=>{t.forEach(s=>{const c=Object.keys(s)[0];if(["main","supplemental"].includes(c)){const o=Object.keys(s[c])[0];o in e?e[o].includes(s)||(e[o]=[...e[o],s]):e[o]=[s]}}),l.load(...t)};exports.load=n;exports.locales=e;
